import apontamentoColetasLocalizacaoReport from "entity/Indicador/reports/ApontamentoColetasLocalizacaoReport";
import apontamentoHeaderLocalizacaoReport from "entity/Indicador/reports/ApontamentoHeaderLocalizacaoReport";
import apontamentoImagesReport from "entity/Indicador/reports/ApontamentoImagesReport";
import apontamentoObservacaoReport from "entity/Indicador/reports/ApontamentoObservacaoReport";
import apontamentoPontosAmostradosReport from "entity/Indicador/reports/ApontamentoPontosAmostradosReport";
import TableReportHelper from "report/helper";

export default async function ngvReport(indicador, visita) {
    const h = new TableReportHelper(visita.data);
    const IndicadorClass = indicador.constructor;

    const apontamentos = visita.getApontamentosByIndicador(indicador);

    const content = [];

    for (const apontamento of apontamentos) {
        const params = visita.cliente.getParams(IndicadorClass, apontamento.tipo, indicador.type)
        const paramItems = visita.cliente.getParamItems(IndicadorClass, apontamento.tipo);

        content.push([
            await apontamentoHeaderLocalizacaoReport(
                visita,
                indicador,
                apontamento,
                params,
                undefined,
                undefined,
                {
                    label: "Operador",
                    field: "operador.operador",
                    width: "*"
                }
            ),
            h.panel(
                [
                    h.row(
                        h.title("Variedade"),
                        h.text(apontamento.insumo),
                        h.title("Turno"),
                        h.text(apontamento.turno),
                    ),
                ],
                { widths: [60, "*", 60, "*"] }
            ),

            await apontamentoColetasLocalizacaoReport(
                visita,
                indicador,
                apontamento,
                [
                    "Qtd. Gemas Viáveis",
                    "Qtd. Gemas Metro",
                    "Conforme",
                    "Danos Pragas/Clima",
                    "Danos Mecânico"
                ],
                // prettier-ignore
                (h) => [
                    h.textField("qtdGemas"),
                    h.numberField("qtdGemasMetro"),
                    h.textField("conforme"),
                    h.numberField("danosPragasClima"),
                    h.numberField("danosMecanico"),
                ],
                [60, 60, 60, 60, 60],
                false // showLocalizacao
            ),

            h.panel(
                [
                    h.row(
                        h.title("Total de Gemas Viáveis", { alignment: "left" }),
                        h.text(apontamento.totalGemas, { alignment: "left" }),
                        h.title("Total", { alignment: "left" }),
                        h.text(apontamento.total, { alignment: "left" })
                    ),
                ],
                { widths: [100, "*", 30, "*"] }
            ),

            apontamentoPontosAmostradosReport(visita, indicador, apontamento, paramItems, "QT"),
            apontamentoImagesReport(visita, indicador, apontamento),
            apontamentoObservacaoReport(visita, indicador, apontamento),

            h.space(),
        ]);
    }

    return content;
}
